import { call, fork, take } from 'redux-saga/effects'
import { bindAsyncAction } from 'typescript-fsa-redux-saga'
import { Action } from 'typescript-fsa'

import { InstagramPostApi } from '../../api/instances'

import { getIgPageFeed, getIgPageFeedInitiated } from './instagram.actions'

import {
  GetInstagramPageFeedRequest,
} from '@3m5/sm_publish-frontend-api/apis/InstagramPostApi'

// getIgPageFeed
const getIgPageFeedWorker = bindAsyncAction(getIgPageFeed)(
  function * (params: GetInstagramPageFeedRequest) {
    return yield call([InstagramPostApi, InstagramPostApi.getInstagramPageFeed], params)
  },
)

function * watchGetIgPageFeedInitiated () {
  while (true) {
    const action: Action<GetInstagramPageFeedRequest> = yield take(getIgPageFeedInitiated)
    try {
      yield getIgPageFeedWorker(action.payload)
    } catch (e) {
      console.error('error in watchGetIgPageFeedInitiated: ', e)
    }
  }
}

export function * instagramSagas () {
  yield fork(watchGetIgPageFeedInitiated)
}
